module.exports = __webpack_public_path__ + "img/guanli.d6ddf5b7.png";